import styled from 'styled-components';

export const CourseName = styled.span`
  font-weight: 500;
`;
